import { render, staticRenderFns } from "./variables.vue?vue&type=template&id=45fa328e&scoped=true&"
import script from "./variables.component.ts?vue&type=script&lang=ts&"
export * from "./variables.component.ts?vue&type=script&lang=ts&"
import style0 from "./variables.vue?vue&type=style&index=0&id=45fa328e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa328e",
  null
  
)

export default component.exports